import {Popover, OverlayTrigger} from 'react-bootstrap'
import styles from './OutletCell.css'
import sortBy from 'lodash/sortBy'

class OutletCell extends React.Component {
  render () {
    const {outlets: outletsProps, allOutlet} = this.props
    const outlets = sortBy(outletsProps, ['name'])
    const popover = (<Popover title='Assigned Outlets' bsClass={`${styles.popover} popover`}>
      <ul>
        {outlets.map((o) => { return <li className={styles['popover-outlet-name']}>&bull; {o.name}</li> })}
      </ul>
    </Popover>)
    if (outlets.length === 1) {
      return <span className={styles['outlet-name']}>{outlets[0].name}</span>
    } else if (allOutlet) {
      return <OverlayTrigger placement='top' overlay={popover}>
        <button className='btn btn-info'>
          All Outlets
        </button>
      </OverlayTrigger>
    } else {
      return <OverlayTrigger placement='top' overlay={popover}>
        <button className='btn btn-success'>{outlets.length} Outlet(s)</button>
      </OverlayTrigger>
    }
  }
}

OutletCell.PropTypes = {
  outlets: React.PropTypes.array,
  allOutlet: React.PropTypes.boolean
}

export default OutletCell



// WEBPACK FOOTER //
// ./app/pages/Employees/Staff/StaffList/OutletCell/OutletCell.js